import React, { useEffect, useState } from 'react';
import { ListContextProvider, useGetList, useList, useRecordContext } from 'react-admin';
import { List, Datagrid, TextField, DateField } from 'react-admin';
import { useDataProvider } from 'react-admin';
import { getToken } from '../authentication/authProvider';

const PAPERMAN_API_URL = process.env.REACT_APP_PAPERMAN_API_URL;

type SendGridEvent = {
  id: string;
  email: string;
  timestamp: string; // or Date if you parse it
  event: string;
  asm_group_id?: number;
};

interface Message {
  id: string;
  from_email: string;
  msg_id: string;
  subject: string;
  to_email: string;
  status: string;
  opens_count: number;
  clicks_count: number;
  last_event_time: string;
}

// Define the interface for the response structure
interface SendGridResponse {
  messages: Message[];
}


const SendGridEventsList = () => {
  const record = useRecordContext();
  const [activityData, setActivityData] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (record) {
      void getActivity(record.email);
    }
  }, [record]);

  const getActivity = async (email: string) => {
    setLoading(true);

    try {
      const response = await fetch(
        PAPERMAN_API_URL + `sendgrid/activity/${email}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      const messageData: SendGridResponse = await response.json();

      if (response.ok) {
        const messagesWithId = messageData.messages.map(msg => ({
          ...msg,
          id: msg.msg_id // Here, 'id' is assigned the value of 'msg_id'
        }));

        setActivityData(messageData.messages);

      } else {
        notify('Error');
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      console.warn(e);

      notify(e.message ?? JSON.stringify(e));
    }

    setLoading(false);

  };

  const { data, total, isLoading, error } = useGetList(
    'sendgrid_events',
    {
      pagination: { page: 1, perPage: 10 },
      sort: { field: 'timestamp', order: 'DESC' },
      filter: { email: record ? record.email : '' },
    },
    { enabled: !!record }
  );

  const listContext = useList({ data, isLoading });
  const activityContext = useList({ data: activityData, isLoading: loading });

  if (!record) return null;

  return (
    <div>
      <h3>SendGrid Events</h3>
      <ListContextProvider value={listContext}>
        <Datagrid bulkActionButtons={false}>
          <DateField source="timestamp" showTime />
          <TextField source="event" />
        </Datagrid>
      </ListContextProvider>
      <ListContextProvider value={activityContext}>
        <Datagrid bulkActionButtons={false}>
          <DateField source="last_event_time" showTime />
          <TextField source="status" />
          <TextField source="opens_count" />
          <TextField source="clicks_count" />
        </Datagrid>
      </ListContextProvider>
    </div>
  );
};

export default SendGridEventsList;
function notify(arg0: any) {
  throw new Error('Function not implemented.');
}

